export default import.meta.ROLLDOWN_FILE_URL_x60af2g7TqorFcgQlznxPQ